import {FileDiffIcon} from '@primer/octicons-react'
import {ForYouItem} from '../shared/ForYouItem'
import {useReviewers} from '../../data/use-reviewers'
import {CompletedReviewRow} from './shared/CompletedReviewRow'
import {ReviewHeaderTitle} from './shared/ReviewHeaderTitle'
import {ReviewHeaderDescription} from './shared/ReviewHeaderDescription'

export function ChangesRequested() {
  const {data: reviewers} = useReviewers()

  const changesRequestedReviews =
    reviewers.completedReviews?.filter(review => review.state === 'changes_requested') ?? []

  if (changesRequestedReviews.length === 0) {
    return null
  }

  return (
    <ForYouItem
      icon={FileDiffIcon}
      title={<ReviewHeaderTitle reviews={changesRequestedReviews} state="changes_requested" />}
      ariaLabel={`${changesRequestedReviews.length} ${changesRequestedReviews.length === 1 ? 'change requested' : 'changes requested'}`}
      itemName="changes-requested"
      variant="danger"
      description={<ReviewHeaderDescription reviews={changesRequestedReviews} />}
    >
      {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
      <ul className="list-none p-0" role="list">
        {changesRequestedReviews.map(review => (
          <CompletedReviewRow key={review.id} review={review} />
        ))}
      </ul>
    </ForYouItem>
  )
}
